module.exports = __webpack_public_path__ + "media/images/logo-13e3a733c9f351163e9af0d3fef1b6a0.png";